/**
 * ProgressHeader Component
 *
 * Displays the agent's step completion count (X / 8) with an animated
 * progress bar. Sticky on mobile so agents always see their progress
 * while scrolling through step cards.
 */

import React from 'react'
import { observer } from 'mobx-react-lite'
import Store from '../../FirstSaleTracker.store'
import ContentHtml from '../../../../components/content/ContentHtml/ContentHtml.component'
import { TOTAL_STEPS } from '../../FirstSaleTracker.constants'

import './ProgressHeader.scss'

const ProgressHeader = () => {
  const { completedCount, isComplete, loading } = Store
  const pct = (completedCount / TOTAL_STEPS) * 100

  return (
    <div className={`progress-header ${isComplete ? 'complete' : ''}`}>
      <ContentHtml contentSlug='fst-introduction' />

      <div className='progress-header__label'>
        {loading ? (
          <span className='text-muted'>Loading...</span>
        ) : (
          <>
            <span className='progress-header__count'>{completedCount}</span>
            <span className='progress-header__separator'> / </span>
            <span>{TOTAL_STEPS} Steps Completed</span>
          </>
        )}
      </div>
      <div className='progress-header__bar'>
        <div
          className='progress-header__fill'
          style={{ width: `${pct}%` }}
          role='progressbar'
          aria-valuenow={completedCount}
          aria-valuemin={0}
          aria-valuemax={TOTAL_STEPS}
          aria-label={`${completedCount} of ${TOTAL_STEPS} steps completed`}
        />
      </div>
    </div>
  )
}

export default observer(ProgressHeader)
